import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f297a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "umbraco-form-field" }

import { PropType } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import UmbracoFormShortAnswer from "@/components/umbraco-forms/inputs/UmbracoFormShortAnswer.vue";
import UmbracoFormLongAnswer from "@/components/umbraco-forms/inputs/UmbracoFormLongAnswer.vue";
import UmbracoFormDate from "@/components/umbraco-forms/inputs/UmbracoFormDate.vue";
import UmbracoFormCheckbox from "@/components/umbraco-forms/inputs/UmbracoFormCheckbox.vue";
import UmbracoFormFileUpload from "@/components/umbraco-forms/inputs/UmbracoFormFileUpload.vue";
import UmbracoFormPassword from "@/components/umbraco-forms/inputs/UmbracoFormPassword.vue";
import UmbracoFormMultipleChoice from "@/components/umbraco-forms/inputs/UmbracoFormMultipleChoice.vue";
import UmbracoFormDataConsent from "@/components/umbraco-forms/inputs/UmbracoFormDataConsent.vue";
import UmbracoFormDropdown from "@/components/umbraco-forms/inputs/UmbracoFormDropdown.vue";
import UmbracoFormSingleChoice from "@/components/umbraco-forms/inputs/UmbracoFormSingleChoice.vue";
import UmbracoFormTitleAndDescription from "@/components/umbraco-forms/inputs/UmbracoFormTitleAndDescription.vue";
import UmbracoFormHidden from "@/components/umbraco-forms/inputs/UmbracoFormHidden.vue";
import UmbracoFormRecaptcha2 from "@/components/umbraco-forms/inputs/UmbracoFormRecaptcha2.vue";
import UmbracoFormRecaptcha3 from "@/components/umbraco-forms/inputs/UmbracoFormRecaptcha3.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormField',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.field.type.name == 'Short answer')
      ? (_openBlock(), _createBlock(UmbracoFormShortAnswer, {
          key: 0,
          field: __props.field
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", { field: __props.field })
          ]),
          _: 3
        }, 8, ["field"]))
      : (__props.field.type.name == 'Long answer')
        ? (_openBlock(), _createBlock(UmbracoFormLongAnswer, {
            key: 1,
            field: __props.field
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", { field: __props.field })
            ]),
            _: 3
          }, 8, ["field"]))
        : (__props.field.type.name == 'Date')
          ? (_openBlock(), _createBlock(UmbracoFormDate, {
              key: 2,
              field: __props.field
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", { field: __props.field })
              ]),
              _: 3
            }, 8, ["field"]))
          : (__props.field.type.name == 'Checkbox')
            ? (_openBlock(), _createBlock(UmbracoFormCheckbox, {
                key: 3,
                field: __props.field
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", { field: __props.field })
                ]),
                _: 3
              }, 8, ["field"]))
            : (__props.field.type.name == 'File upload')
              ? (_openBlock(), _createBlock(UmbracoFormFileUpload, {
                  key: 4,
                  field: __props.field
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default", { field: __props.field })
                  ]),
                  _: 3
                }, 8, ["field"]))
              : (__props.field.type.name == 'Password')
                ? (_openBlock(), _createBlock(UmbracoFormPassword, {
                    key: 5,
                    field: __props.field
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default", { field: __props.field })
                    ]),
                    _: 3
                  }, 8, ["field"]))
                : (__props.field.type.name == 'Multiple choice')
                  ? (_openBlock(), _createBlock(UmbracoFormMultipleChoice, {
                      key: 6,
                      field: __props.field
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default", { field: __props.field })
                      ]),
                      _: 3
                    }, 8, ["field"]))
                  : (__props.field.type.name == 'Data Consent')
                    ? (_openBlock(), _createBlock(UmbracoFormDataConsent, {
                        key: 7,
                        field: __props.field
                      }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "default", { field: __props.field })
                        ]),
                        _: 3
                      }, 8, ["field"]))
                    : (__props.field.type.name == 'Dropdown')
                      ? (_openBlock(), _createBlock(UmbracoFormDropdown, {
                          key: 8,
                          field: __props.field
                        }, {
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default", { field: __props.field })
                          ]),
                          _: 3
                        }, 8, ["field"]))
                      : (__props.field.type.name == 'Single choice')
                        ? (_openBlock(), _createBlock(UmbracoFormSingleChoice, {
                            key: 9,
                            field: __props.field
                          }, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "default", { field: __props.field })
                            ]),
                            _: 3
                          }, 8, ["field"]))
                        : (__props.field.type.name == 'Title and description')
                          ? (_openBlock(), _createBlock(UmbracoFormTitleAndDescription, {
                              key: 10,
                              field: __props.field
                            }, {
                              default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "default", { field: __props.field })
                              ]),
                              _: 3
                            }, 8, ["field"]))
                          : (__props.field.type.name == 'Hidden')
                            ? (_openBlock(), _createBlock(UmbracoFormHidden, {
                                key: 11,
                                field: __props.field
                              }, {
                                default: _withCtx(() => [
                                  _renderSlot(_ctx.$slots, "default", { field: __props.field })
                                ]),
                                _: 3
                              }, 8, ["field"]))
                            : (__props.field.type.name == 'Recaptcha2')
                              ? (_openBlock(), _createBlock(UmbracoFormRecaptcha2, {
                                  key: 12,
                                  field: __props.field
                                }, {
                                  default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "default", { field: __props.field })
                                  ]),
                                  _: 3
                                }, 8, ["field"]))
                              : (__props.field.type.name == 'reCAPTCHA v3 with score')
                                ? (_openBlock(), _createBlock(UmbracoFormRecaptcha3, {
                                    key: 13,
                                    field: __props.field
                                  }, {
                                    default: _withCtx(() => [
                                      _renderSlot(_ctx.$slots, "default", { field: __props.field })
                                    ]),
                                    _: 3
                                  }, 8, ["field"]))
                                : _createCommentVNode("", true)
  ]))
}
}

})